import React from "react";

/**
 * Plain text bubble — gold for customer, cream for astrologer. The
 * read-receipt tick is rendered by the parent so it can be hidden behind
 * any layout/state logic that doesn't belong inside a presentational bubble.
 */
const TextMessage = ({ text, isCustomer }) => (
  <div
    className={`rounded-2xl px-3.5 sm:px-4 py-2 sm:py-2.5 text-sm leading-relaxed whitespace-pre-wrap break-words ${
      isCustomer
        ? "bg-[#D4AF37] text-[#1A1410] rounded-br-sm"
        : "bg-[#FAF4E8] border border-soft text-[#1A1410] rounded-bl-sm"
    }`}
  >
    {text}
  </div>
);

export default TextMessage;
